import _ from 'lodash';
import * as types from '../mutation-types';
import partners from '../../api/partners';
import users from '@/api/user';

const state = {
  partners: [],
  includeDisabled: false,
  selected: {
    id: null,
    logo: null,
    campaigns: {},
    excluded_businesses: []
  },
  search: '',
  children: [],
  selectedChild: {
    id: null,
    logo: null
  },
  funder_companies: []
};

const getters = {
  PartnersList: state => state.partners,
  PartnersIncludeDisabled: state => state.includeDisabled,
  PartnerSearch: state => state.search,
  SelectedPartner: state => state.selected,
  PartnerMembers: state => state.children,
  SelectedPartnerMember: state => state.selectedChild,
  FunderCompanies: state => state.funder_companies
};

const actions = {
  getPartnersList({ commit, dispatch, state }) {
    partners.getPartnersList(state.includeDisabled).then(response => {
      commit(types.SET_PARTNERS_LIST, response.data);
      if (response.data.length > 0) {
        dispatch('selectPartner', response.data[0].id);
      }
    });
  },
  selectPartner({ commit, dispatch }, id) {
    dispatch('getPartnerChildren', id);
    partners.getPartner(id).then(response => commit(types.SELECT_PARTNER, response.data));
  },
  getPartnerChildren({ commit, dispatch }, id) {
    partners.getPartnerChildren(id).then(response => {
      if (response.data.length > 0) {
        dispatch('selectPartnerChild', response.data[0].id);
        commit(types.SET_PARTNER_CHILDREN, response.data);
      }
    });
  },
  selectPartnerChild({ commit }, id) {
    partners.getPartner(id).then(response => commit(types.SET_SELECTED_PARTNER_CHILD, response.data));
  },
  registerPartner({ dispatch }, partner) {
    return new Promise((resolve, reject) => {
      partners
        .register(partner)
        .then(() => {
          dispatch('getPartnersList');
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  updateSelectedPartner({ commit, dispatch }, updates) {
    const partnerId = state.selected.id;
    return new Promise((resolve, reject) => {
      partners
        .update(partnerId, updates)
        .then(partner => {
          if (state.selected.parent_id !== partner.data.parent_id) {
            dispatch('getPartnersList');
          } else {
            dispatch('selectPartner', partnerId);
            commit(types.SET_SELECTED_PARTNER_IN_LIST, partner.data);
          }
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  updatePartnerUser({ dispatch, state }, { id, updates }) {
    const partnerId = state.selected.id;
    return new Promise((resolve, reject) => {
      users
        .updateUser(id, updates)
        .then(() => {
          dispatch('selectPartner', partnerId);
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  sendPartnerWelcomeMessage({ dispatch, state }, id) {
    const partnerId = state.selected.id;
    return new Promise((resolve, reject) => {
      users
        .sendWelcomeMessage(id)
        .then(() => {
          dispatch('selectPartner', partnerId);
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  updatePartnerCampaign({ dispatch }, updates) {
    const partnerId = state.selected.id;
    return new Promise((resolve, reject) => {
      partners
        .updateCampaign(updates)
        .then(() => {
          dispatch('selectPartner', partnerId);
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  addPartnerCampaign({ dispatch }, updates) {
    const partnerId = state.selected.id;
    return new Promise((resolve, reject) => {
      partners
        .addCampaign(updates)
        .then(() => {
          dispatch('selectPartner', partnerId);
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  setPartnerSearch({ commit }, search) {
    commit(types.SET_PARTNER_SEARCH, search);
  },
  getFunderCompanies({ commit }) {
    partners.getFunderCompanies().then(funders => {
      commit(types.SET_FUNDER_COMPANIES, funders.data);
    });
  },
  attachExcludedBusiness({ dispatch }, { id, excludedBusinessId }) {
    partners.attachExcludedBusiness(id, excludedBusinessId).then(() => {
      dispatch('selectPartner', id);
    });
  },
  detachExcludedBusiness({ dispatch }, { id, excludedBusinessId }) {
    partners.detachExcludedBusiness(id, excludedBusinessId).then(() => {
      dispatch('selectPartner', id);
    });
  },
  attachExcludedJourney({ dispatch }, { id, excludedJourneyId }) {
    partners.attachExcludedJourney(id, excludedJourneyId).then(() => {
      dispatch('selectPartner', id);
    });
  },
  detachExcludedJourney({ dispatch }, { id, excludedJourneyId }) {
    partners.detachExcludedJourney(id, excludedJourneyId).then(() => {
      dispatch('selectPartner', id);
    });
  },
  showDisabledPartners({ commit }, shouldInclude) {
    commit(types.SET_PARTNERS_INCLUDE_DISABLED, shouldInclude);
  }
};

const mutations = {
  [types.SET_PARTNERS_LIST](state, partners) {
    state.partners = partners;
  },
  [types.SET_PARTNERS_INCLUDE_DISABLED](state, shouldIncludeDisabled) {
    state.includeDisabled = shouldIncludeDisabled;
  },
  [types.SET_SELECTED_PARTNER_IN_LIST](state, response) {
    let id = response.id;
    let parentId = response.parent_id;
    if (_.isNull(parentId)) {
      let index = _.findIndex(state.partners, { id });
      _.merge(state.partners[index], response);
    } else {
      let index = _.findIndex(state.partners, { id: parentId });
      let subIndex = _.findIndex(state.partners[index]['children'], { id });
      _.merge(state.partners[index]['children'][subIndex], response);
    }
  },
  [types.SELECT_PARTNER](state, partner) {
    state.selected = partner;
  },
  [types.SET_PARTNER_CHILDREN](state, children) {
    state.children = children;
  },
  [types.SET_SELECTED_PARTNER_CHILD](state, child) {
    state.selectedChild = child;
  },
  [types.SET_PARTNER_SEARCH](state, search) {
    state.search = search;
  },
  [types.SET_FUNDER_COMPANIES](state, funders) {
    state.funder_companies = funders;
  },
  [types.CLEAR_SELECTED_PARTNER](state) {
    state.selected = {
      id: null,
      logo: null,
      campaigns: {},
      excluded_businesses: []
    };
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
